import $ from 'jquery';
import _ from 'underscore';
import {setElementsFromScope, show, hide, handleDisplayFor, formatAddress} from '../../utilities/run';
import { isPresent } from '../../utilities/general';
import {anyChecked} from './utilities';

const elementsMap = {
	amazonPartnerNameReviewTab : ".review-tab-partner-name",
	amazonPartnerName : "#amazonPartnerNameId",

	amazonConnectionDescriptionReviewTab :".review-tab-connection-description",
	amazonConnectionDescription : "#amazonConnectionDescriptionId",

	amazonSellerIdReviewTab : ".review-tab-amazon-seller-id",
	amazonSellerId : "#amazonSellerId",

	amazonMarketplaceIdReviewTab : ".review-tab-amazon-marketplace-id",
	amazonMarketplaceId : "#amazonMarketplaceId",

	amazonAwsAccessKeyIdReviewTab : ".review-tab-amazon-aws-access-key-id",
	amazonAwsAccessKeyId : "#amazonAwsAccessKeyId",

	amazonSecretKeyReviewTab : ".review-tab-amazon-secret-key-id",
	amazonSecretKey : "#amazonSecretKey",

	sectionTitlesReviewTab: ".section-step-title-inner",

  amazonCurrentConnectionStatusReviewTab : ".test-status",
  amazonCurrentConnectionStatus : ".current-status-of-amazon-connection",

  amazonConnectionStatus: ".connection-status",
  amazonReviewTabConnectionStatus: ".review-tab-connection-status",

  orderProcessingIcon: "#orderProcessingIcon",
  reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",

  inventorySyncIcon: "#inventorySyncIcon",
  reviewTabInventorySyncIcon: "review-tab-inventory-sync-icon",

  orderProcessingStatusYes: ".order-processing-status-yes",
  orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",

  inventorySyncStatusYes: ".inventory-sync-status-yes",

  orderProcessingStatusNo: ".order-processing-status-no",
  inventorySyncStatusNo: ".inventory-sync-status-no",

  startDate:".start-date",
  timePickerHoursSelect: ".time-picker-hours-select",
  timePickerMinSelect: ".time-picker-minutes-select",
  timePickerPeriodSelect: ".time-picker-period-select",

  
  reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
  reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
  reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",

  reviewTabDateSetter: ".review-tab-start-date-td",
  reviewTabTimeSetter: ".review-tab-start-time-td",

  orderProcessingDateTimeOptionsSelect:".orderProcessingDateTimeOptions",

  realtimeApiApplicationName: "#realtimeApiApplicationName",
  reviewTabRealtimeApiApplicationName: ".review-tab-api-connection-application-name",

  realtimeApiClientId: "#realtimeApiClientId",
  reviewTabRealtimeApiClientId: ".review-tab-api-connection-client-id",
}

export default function ReviewTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const retpartner =wizardElement.data("retailer-partners-info");
  const els = {};
  let orderProcessingIconStatusReviewTab=false;
  let inventorySyncIconStatusReviewTab=false;
  let orderProcessingSelectValue="";

  self.init = function(){
    setElements();
    bindElements();
    fillChannelsReviewTab();
  };

  self.didNavigateToForm = function(){
    fillChannelsReviewTab();
  };


  function bindElements(){
    els.sectionTitlesReviewTab.bind('click', function(){
      const form = wizardElement.find($(this).data("target-form"));
      wizard.gotToForm(form);
    });
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setElementsFromScope(targetObj, elementsDict, scope){
    _(elementsDict).each((v, k)=>{
      //console.log(`${v} ${k}`)
      targetObj[k] = scope.find(v);
    });
  }

  function fillChannelsReviewTab(){
  	els.amazonPartnerNameReviewTab.text(els.amazonPartnerName.val());
  	els.amazonSellerIdReviewTab.text(els.amazonSellerId.val());
  	els.amazonConnectionDescriptionReviewTab.text(els.amazonConnectionDescription.val());
  	els.amazonMarketplaceIdReviewTab.text(els.amazonMarketplaceId.val());
  	els.amazonAwsAccessKeyIdReviewTab.text(els.amazonAwsAccessKeyId.val());
  	els.amazonSecretKeyReviewTab.text(els.amazonSecretKey.val());
    els.amazonCurrentConnectionStatusReviewTab.text(els.amazonCurrentConnectionStatus.val());
    els.amazonReviewTabConnectionStatus.text(els.amazonConnectionStatus.val());
    $(".review-tab-active-since").text(dateFromatCustomChange(retpartner.repActiveSince));
    $(".review-tab-partner-name").text(retpartner.parName);

    setConfigurationReviewSection();

    els.reviewTabRealtimeApiApplicationName.text(els.realtimeApiApplicationName.val());
    els.reviewTabRealtimeApiClientId.text(els.realtimeApiClientId.val());
  }

  function setConfigurationReviewSection(){
    orderProcessingIconStatusReviewTab=anyChecked(els.orderProcessingIcon);
    setOrderProcessingOnReviewTab(orderProcessingIconStatusReviewTab);
    inventorySyncIconStatusReviewTab=anyChecked(els.inventorySyncIcon);
    setInventorySyncOnReviewTab(inventorySyncIconStatusReviewTab);
    setReviewTabDate();
  }

  function setOrderProcessingOnReviewTab(data){
    if(data){
      els.orderProcessingStatusYes.show();
      els.orderProcessingDateTimeYes.show();
      els.orderProcessingStatusNo.hide();
    }else{
      els.orderProcessingStatusYes.hide();
      els.orderProcessingDateTimeYes.hide();
      els.orderProcessingStatusNo.show();
    }
  }

  function setInventorySyncOnReviewTab(data){
    if(data){
      els.inventorySyncStatusYes.show();
      els.inventorySyncStatusNo.hide();
    }else{
      els.inventorySyncStatusYes.hide();
      els.inventorySyncStatusNo.show();
    }
  }

  function setReviewTabDate(){
    els.reviewTabDateSetter.text(els.startDate.val());
    setReviewTabTime();
    hideShowStartTimeSection();
  }

  function setReviewTabTime(){
    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
  }

  function hideShowStartTimeSection() {
    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();
    
    if ((orderProcessingSelectValue == "future" || orderProcessingSelectValue == "past") ||
             isPresent(els.startDate.val())) {
      els.orderProcessingDateTimeYes.show();
    } else {
      els.orderProcessingDateTimeYes.hide();
    }
  }

  function dateFromatCustomChange(activeSince){
    if(activeSince!=null){
      var date = convertUTCDateToLocalDate(new Date(activeSince));
    }else{
      var date = new Date();
    }
    var curr_day = date.getDate();
    var curr_month = date.getMonth();
    var curr_year = date.getFullYear();
    curr_month++ ; // In js, first month is 0, not 1
    var newDate = curr_month + "/" + curr_day + "/" + curr_year;
    return newDate;
  }

  function convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;   
  }
}



// WEBPACK FOOTER //
// ./src/pages/createChannel/reviewTab.js